import React, { useState } from "react";
import { Navbar, Footer } from "@/components/yc/Nav";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { CheckCircle2, KeyRound } from "lucide-react";

const FIELDS = [
    ["contact_name", "Contact name", "text", "Jane Smith"],
    ["email", "Email", "email", "jane@yourbrand.com"],
    ["phone", "Phone number", "tel", "+44 7000 000000"],
    ["location", "Location", "text", "Leicester, UK"],
    ["num_locations", "Number of locations", "text", "e.g. 3"],
];

const BrandJoin = () => {
    const [form, setForm] = useState({ contact_name: "", email: "", phone: "", location: "", num_locations: "" });
    const [busy, setBusy] = useState(false);
    const [done, setDone] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        const missing = FIELDS.filter(([k]) => !form[k].trim()).map(([, l]) => l);
        if (missing.length) {
            toast.error(`Please complete: ${missing.join(", ")}`);
            return;
        }
        setBusy(true);
        try {
            await api.post("/public/brand-lead", form);
            setDone(true);
        } catch (err) {
            const detail = err.response?.data?.detail;
            toast.error(Array.isArray(detail) ? detail.map((d) => d.msg).join("; ") : (detail || "Could not submit — please check your details"));
        } finally { setBusy(false); }
    };

    return (
        <div className="min-h-screen bg-yc-cream flex flex-col">
            <Navbar />
            <section className="flex-1 flex items-center justify-center px-6 py-16">
                {done ? (
                    <div className="yc-card p-10 max-w-md w-full text-center" data-testid="brand-lead-success">
                        <CheckCircle2 className="w-12 h-12 text-yc-blue mx-auto" />
                        <h1 className="font-heading text-3xl font-black tracking-tighter mt-4">You&apos;re on the list.</h1>
                        <p className="text-sm text-yc-ink/70 mt-3 leading-relaxed">
                            Thanks — our team will review your enquiry and send your <strong>unique access code</strong> to your email. Once you have it, sign in with Google and enter the code to unlock your brand account.
                        </p>
                    </div>
                ) : (
                    <div className="yc-card p-10 max-w-md w-full">
                        <div className="yc-overline">For Brands</div>
                        <h1 className="font-heading text-4xl font-black tracking-tighter mt-3">Join the network.</h1>
                        <p className="text-sm text-yc-ink/70 mt-3">
                            Brand membership is invite-only. Tell us about your business and we&apos;ll send you a unique access code to join.
                        </p>
                        <form onSubmit={submit} className="mt-8 space-y-4">
                            {FIELDS.map(([k, label, type, ph]) => (
                                <div key={k}>
                                    <label className="yc-overline">{label} *</label>
                                    <input
                                        data-testid={`blead-${k.replace("_", "-")}`}
                                        type={type}
                                        className="yc-input mt-1.5"
                                        placeholder={ph}
                                        value={form[k]}
                                        onChange={(e) => setForm({ ...form, [k]: e.target.value })}
                                    />
                                </div>
                            ))}
                            <button data-testid="blead-submit" disabled={busy} className="yc-btn-primary w-full disabled:opacity-50">
                                {busy ? "Sending…" : "Request my access code"}
                            </button>
                        </form>
                        <p className="text-xs text-yc-ink/50 mt-5 flex items-start gap-2">
                            <KeyRound className="w-3.5 h-3.5 mt-0.5 shrink-0" />
                            Already have a code? <a href="/login" className="text-yc-blue font-semibold underline ml-1">Sign in with Google</a> and enter it when choosing &ldquo;I&apos;m a brand&rdquo;.
                        </p>
                    </div>
                )}
            </section>
            <Footer />
        </div>
    );
};

export default BrandJoin;
